import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelfRegisterFormComponent } from './self-register-form/self-register-form.component';
import { ApiSharedModule } from '@icullen/api/shared';
import { ApiPublicModule } from '@icullen/api/public';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivateAccountComponent } from './self-register-form/activate-account/activate-account.component';

@NgModule({
  imports: [
    CommonModule,
    ApiSharedModule,
    ApiPublicModule,
    MatFormFieldModule,
    MatStepperModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    ReactiveFormsModule
  ],
  declarations: [
    SelfRegisterFormComponent,
    ActivateAccountComponent
  ],
})
export class PublicModule {}
